// Политика обработки персональных данных. ЧЕРНОВИК — текст требует проверки юристом
// и утверждения. Реквизиты оператора — ООО «ЛИЛИАНИ».
export const PrivacyView = () => {
  return (
    <div className="container max-w-[900px] py-10 text-[15px] leading-relaxed text-[#1f2a2e]">
      <h1 className="mb-6 text-[26px] font-semibold">
        Политика обработки персональных данных
      </h1>

      <p className="mb-4 rounded bg-[#FFF7E6] p-3 text-[13px] text-[#8a6d3b]">
        Черновик. Документ подлежит проверке и утверждению до публикации.
      </p>

      <h2 className="mb-2 mt-6 text-[18px] font-semibold">1. Оператор</h2>
      <p className="mb-4">
        Оператором персональных данных является ООО «ЛИЛИАНИ» (ИНН 6162031892,
        ОГРН 1026103053426), адрес: 346884, Ростовская обл., г. Батайск,
        Восточное шоссе, 14, пом. 401. Контакты: 8 (800) 555 99 83,
        office@liliani.ru.
      </p>

      <h2 className="mb-2 mt-6 text-[18px] font-semibold">2. Какие данные обрабатываются</h2>
      <p className="mb-4">
        При оформлении заявки в конфигураторе обрабатываются: фамилия, имя,
        отчество, контактный телефон, адрес электронной почты, наименование
        организации (при указании), а также комментарий и состав выбранной
        конфигурации техники.
      </p>

      <h2 className="mb-2 mt-6 text-[18px] font-semibold">3. Цели обработки</h2>
      <p className="mb-4">
        Обработка осуществляется в целях обработки заявки, связи с пользователем,
        подготовки коммерческого предложения и согласования условий поставки
        техники.
      </p>

      <h2 className="mb-2 mt-6 text-[18px] font-semibold">4. Правовое основание</h2>
      <p className="mb-4">
        Обработка осуществляется на основании согласия субъекта персональных
        данных, которое он даёт при отправке заявки.
      </p>

      <h2 className="mb-2 mt-6 text-[18px] font-semibold">5. Передача данных</h2>
      <p className="mb-4">
        Данные могут передаваться в систему управления взаимоотношениями с
        клиентами (CRM) оператора для обработки заявки. Иным третьим лицам данные
        не передаются, за исключением случаев, предусмотренных законодательством
        РФ.
      </p>

      <h2 className="mb-2 mt-6 text-[18px] font-semibold">6. Сроки и защита</h2>
      <p className="mb-4">
        Данные хранятся не дольше, чем требуется для целей обработки или
        законодательством. Оператор принимает необходимые правовые,
        организационные и технические меры для защиты персональных данных.
      </p>

      <h2 className="mb-2 mt-6 text-[18px] font-semibold">7. Права пользователя</h2>
      <p className="mb-4">
        Пользователь вправе запросить сведения об обработке своих персональных
        данных, их уточнение, блокирование или удаление, а также отозвать
        согласие, направив обращение по адресу office@liliani.ru.
      </p>
    </div>
  );
};
